import React, { useEffect } from "react";
import PropTypes from "prop-types";

export default function PuppyPoolPartyClinicScore({
    data,
    pathToSrcFiles = "puppy_pool_party_leaderboard/",
}) {

    const loadHtml = () => ({
        __html: `
            <iframe
                id="puppy-pool-party-points-gained-iframe"
                src="${pathToSrcFiles}index.html"
                width="100%"
                height="100%"
                style="border-width: 0; padding: 0;"
            />
        `
    });

    const waitForIframeHtmlToLoad = () => {
        const intervalId = setInterval(() => {
            if (!!window.PuppyPoolPartyPointsGained) {
                // Js has loaded
                new window.PuppyPoolPartyPointsGained(data);
                clearInterval(intervalId);
            }
        }, 200);
    };

    useEffect(() => {
        waitForIframeHtmlToLoad();
    }, []);

    return (
        <div dangerouslySetInnerHTML={loadHtml()} />
    );
}

PuppyPoolPartyClinicScore.propTypes = {
    data: PropTypes.shape({
        totalDoses: PropTypes.number,
        newDoses: PropTypes.number,
        bonus: PropTypes.number,
    }),
    pathToSrcFiles: PropTypes.string,
};
